export const uncamelize = (str, upperFirst = true, replaceSpace = null) => {
  let ret = str.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/\b([A-Z0-9]+)([A-Z0-9])([a-z0-9])/, '$1 $2$3')
  ret = ret.toLowerCase()
  if (upperFirst)
    ret = ret.charAt(0).toUpperCase() + ret.slice(1)
  if (replaceSpace)
    ret = ret.replace(/ /g, replaceSpace)
  return ret
}

export const camelize = (str) => {
  // Lower cases the string
  return str.toLowerCase()
    // Replaces any - or _ characters with a space
    .replace( /[-_]+/g, ' ')
    // Removes any non alphanumeric characters
    .replace( /[^\w\s]/g, '')
    // Uppercases the first character in each group immediately following a space
    // (delimited by spaces)
    .replace( / (.)/g, function($1) { return $1.toUpperCase(); })
    // Removes spaces
    .replace( / /g, '' );
}

export const capitalize = (str) => {
  return str[0].toUpperCase() + str.slice(1);
}
